import { useTranslation } from "react-i18next";
import { isExcluded, levelTone, normalizeRiskLevel, normalizeRiskStatus, statusTone } from "./riskUtils";

export function RiskLevelBadge({ level, excluded }) {
  const { t } = useTranslation();
  if (excluded) {
    return (
      <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${statusTone("skipped")}`}>
        {t("hse.risk.status.skipped")}
      </span>
    );
  }
  const normalized = normalizeRiskLevel(level);
  if (!normalized) {
    return (
      <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${statusTone("draft")}`}>
        {t("hse.risk.level.unset")}
      </span>
    );
  }
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${levelTone(normalized)}`}>
      {t(`hse.risk.level.${normalized}`)}
    </span>
  );
}

export function RiskStatusBadge({ record }) {
  const { t } = useTranslation();
  const excluded = isExcluded(record);
  const status = excluded ? "skipped" : normalizeRiskStatus(record.status);
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${statusTone(status)}`}>
      {t(`hse.risk.status.${status}`)}
    </span>
  );
}
